import React, { useState } from 'react';
import { playRatingSound } from '../utils/sound';
import './RatingOnlyModal.css';

export function RatingOnlyModal({ show, onClose, onSubmit, currentRating = 0 }) {
  const [rating, setRating] = useState(currentRating);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (isSubmitting || rating === 0) return;
    
    setIsSubmitting(true);
    
    try {
      await onSubmit(rating);
      onClose();
    } catch (error) {
      console.error('Error submitting rating:', error);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="rating-modal">
        <h3>Rösta på "{show.title}"</h3>
        <div className="rating-stars">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              className="rating-star"
              onClick={() => setRating(star)}
              onMouseEnter={() => setHoveredRating(star)}
              onMouseLeave={() => setHoveredRating(0)}
              disabled={isSubmitting}
            >
              <img 
                src={star <= (hoveredRating || rating) 
                  ? "/images/strawberry-filled.png" 
                  : "/images/strawberry-empty.png"} 
                alt={`Rating ${star}`}
                className={`strawberry-icon ${isSubmitting ? 'submitting' : ''}`}
              />
            </button>
          ))}
        </div>
        <div className="modal-actions">
          <button 
            className="cancel-button" 
            onClick={onClose}
            disabled={isSubmitting}
          >
            Avbryt
          </button>
          <button 
            className="submit-button" 
            onClick={handleSubmit}
            disabled={rating === 0 || isSubmitting}
          >
            {isSubmitting ? 'Sparar...' : 'Rösta'}
          </button>
        </div>
      </div>
    </div>
  );
} 